<template>
    <el-container>
        <div class="card-deal">
            <div class="card-deal-header caption-block">
                <div class="title">
                    Карточка сделки
                </div>
                <div class="actions">
                    <div class="btn btn-default orange action-edit" @click="save" v-if="canEdit">
                        сохранить
                    </div>
                    <div class="btn btn-default grey action-close" @click="close">
                        закрыть
                    </div>
                </div>
            </div>
            <div class="center-wrapper">
                <div class="card-deal-key-info row">
                    <div class="top">
                        <div class="grey">
                            <span>ID </span>
                            <span>{{ dealId }}</span>
                        </div>
                        <div class="name">
                            {{ title }} ({{ address }})
                        </div>
                        <div class="phone">
                        </div>
                    </div>
                    <key-info />
                </div>
            </div>
            <el-row class="card-deal-tabs">
                <div
                    v-for="tab in tabs"
                    :key="tab.component"
                    :deal-id="dealId"
                    :class="['tab-name', { active: currentTab === tab.component }]"
                    @click="currentTab = tab.component"
                >
                    {{ tab.title }}
                </div>
            </el-row>
            <keep-alive>
                <component :is="currentTab" :deal-id="this.id" />
            </keep-alive>
        </div>
    </el-container>
</template>
<script>
import { eventBus } from '@/common/eventBus';
import Card from './Card';
import KeyInfo from './card-blocks/KeyInfo';
import MainInfoMobile from './card-tabs/MainInfoMobile';
import TasksMobile from './card-tabs/TasksMobile';
import EventsMobile from '@/components/events/EventsMobile';
import IncomeMobile from './card-tabs/IncomeMobile';

export default {
    name: 'DealCardMobile',
    extends: Card,
    data() {
        return {
            loading: true,
            data: {},
            currentTab: 'main-info',
            tabs: [
                { component: 'main-info', title: 'общая информация' },
                { component: 'tasks', title: 'задачи' },
                { component: 'events', title: 'события' },
                { component: 'incomes', title: 'приходы' }
            ]
        };
    },
    components: {
        'key-info': KeyInfo,
        'tasks': TasksMobile,
        'events': EventsMobile,
        'main-info': MainInfoMobile,
        'incomes': IncomeMobile
    },
    computed: {
        dealId() {
            return this.$store.state.deals.current.id;
        },
        canEdit() {
            const roles = this.$store.state.auth.roles;
            const intersection = Object.keys(roles).filter(x => this.approvedRoles.includes(x));
            return intersection.length > 0;
        },
        approvedRoles() {
            return this.$store.getters['references/rolesBySectionDeal'];
        }
    },
    methods: {
        save() {
            this.loading = true;
            const action = this.isNew ? 'createDeal' : 'updateDeal';
            this.$store.dispatch('deals/' + action)
                .then(() => {
                    this.$store.dispatch('references/loadReferenceByName', 'tags');
                    if (this.dealId) {
                        eventBus.$emit('tasks-need-update', { entityType: 'deal', entityId: this.dealId });
                        eventBus.$emit('status-updated', this.$store.state.deals.current.status_id);
                        this.$message({
                            showClose: true,
                            message: 'Карточка сделки успешно сохранена',
                            type: 'success',
                            duration: 5000,
                            customClass: this.alertClass()
                        });
                        this.$router.push({ name: 'deal-card', params: { id: '' + this.dealId } });
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => { this.loading = false; });
        },
        close() {
            this.$router.push({ name: 'deals' });
        }
    }
};
</script>
